import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.sendMessage.loading;
export const sendMessageErrorMessage = (state: RootState) =>
  state.sendMessage.error;
export const sendMessageDataResponse = (state: RootState) =>
  state.sendMessage.sendMessageResponse;
